import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'

class Promo extends Component {
  render() {
    const {message, link} = this.props

    if (!message) return null;

    let linkEl

    if (link) { linkEl = <NavLink className="promo__link" to="/contact">{link}</NavLink> }

    return (
      <div className="promo">
        <span className="promo__label">{message}</span>
        {linkEl}
      </div>
    );
  }
}

Promo.defaultProps = {
  message: "",
  link: ""
};

Promo.propTypes = {
  link: PropTypes.string,
  message: PropTypes.string
}

export default Promo;



// WEBPACK FOOTER //
// ./src/components/promo/index.js